/**
 * Music enjoyed making this
 * 🎧 Childish Gambino - 3.15.20
 * 🎧 https://drain831.bandcamp.com/
 * 🎧 Glitterer - Looking Through the Shades
 * 🎧 The Menzingers - Hello Exile
 *
 * This code has been inspired by the 🐅 Tiger 🐅 👑 King 👑 aka Joe Exotic. Rawreow!
      ("\ '' /").___..--' ' "`-._
      `ಠ_ ಠ  )   `-.  (       ).`-.__.`)
      (_Y_.)'    ._   )  `._ `. ``-..-'
    _..`--'_. .-_/  /--'_.'  .'
  (i l).-' '    ((i). '   ((!.-'
 */
import Vue from 'vue';
import Vuex from 'vuex';

import { state } from './state';
import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';

Vue.use(Vuex);
Vue.config.devtools = true;

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
});
